"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/teamSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Dr. Karen Perez" | "Dr. Brenda Rey" | "Dr. Emily Chen" | "Dr. Liam Brook" */
    link0Text: ReactNode;
    /** Detected variants: "Heart Care Consultant" | "Cardiac Care Specialist" | "Lead Heart Specialist" | "Cardiac Surgeon" */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-1.png" | "/Templates/Doccure/img/team/team-img-2.png" | "/Templates/Doccure/img/team/team-img-4.png" | "/Templates/Doccure/img/team/team-img-3.png" */
    src: string;
    /** Detected variants: "col-xl-3 col-md-6 d-flex wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "team-item-seven flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "team-content" */
    div0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    href?: string;
    /** Detected variants: "team-img" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href?: string;
    /** Detected variants: "doctor" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};

type TeamSectionPartnerSevensItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-15.svg" | "/Templates/Doccure/img/company/company-16.svg" | "/Templates/Doccure/img/company/company-17.svg" | "/Templates/Doccure/img/company/company-18.svg" | "/Templates/Doccure/img/company/company-19.svg" | "/Templates/Doccure/img/company/company-20.svg" */
    src: string;
    /** Detected variants: "partner-item-seven" */
    className?: string;
    /** Detected variants: "client logo" */
    alt?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeSevenTeamSectionGeneratedProps = {
    divDiv0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionPartnerSevensItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "Our Expert Team" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Explore the team cardiology" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "in their Success" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    sectionDiv0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    teamSection36FadeInUps: TeamSection36FadeInUpsItem[];
    teamSectionPartnerSevens: TeamSectionPartnerSevensItem[];
    teamSection36FadeInUpsItemWrapper?: (item: TeamSection36FadeInUpsItem, content: ReactNode) => ReactNode;
    teamSection36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsLinkVisible?: boolean;
    teamSection36FadeInUpsLinkRenderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsImageVisible?: boolean;
    teamSection36FadeInUpsImageRenderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsH3Visible?: boolean;
    teamSection36FadeInUpsH3Renderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSection36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    teamSectionPartnerSevensItemWrapper?: (item: TeamSectionPartnerSevensItem, content: ReactNode) => ReactNode;
    teamSectionPartnerSevensRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionPartnerSevensImageVisible?: boolean;
    teamSectionPartnerSevensImageRenderer?: (item: TeamSectionPartnerSevensItem, defaultNode: ReactNode) => ReactNode;
    teamSectionPartnerSevensImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionPartnerSevensItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeSevenTeamSectionGenerated: FC<HomeSevenTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Our Expert Team",
    sectionDiv0Div0H20H2Text = "Explore the team cardiology",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "in their Success",
    divDiv0Div0H30H3Props,
    divDiv0Div0H30Link0LinkProps,
    divDiv0Link0ImageWithBasePath0ImageProps,
    divDiv0Link0LinkProps,
    divImageWithBasePath0ImageProps,
    sectionDiv0Slider0SliderProps,
    sectionDiv0Div1ClassName,
    teamSection36FadeInUps,
    teamSectionPartnerSevens,
    teamSection36FadeInUpsItemWrapper,
    teamSection36FadeInUpsRenderer,
    teamSection36FadeInUpsLinkVisible,
    teamSection36FadeInUpsLinkRenderer,
    teamSection36FadeInUpsImageVisible,
    teamSection36FadeInUpsImageRenderer,
    teamSection36FadeInUpsH3Visible,
    teamSection36FadeInUpsH3Renderer,
    teamSection36FadeInUpsLinkProps,
    teamSection36FadeInUpsImageProps,
    teamSection36FadeInUpsH3Props,
    teamSectionPartnerSevensItemWrapper,
    teamSectionPartnerSevensRenderer,
    teamSectionPartnerSevensImageVisible,
    teamSectionPartnerSevensImageRenderer,
    teamSectionPartnerSevensImageProps,
}) => {
    return (
        <section className="team-section-seven section">
            <div className="container">
                <div className="section-header section-header-seven text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        teamSection36FadeInUps,
                        (item: TeamSection36FadeInUpsItem) => (
                            <div className={item.className ?? "col-xl-3 col-md-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-seven flex-fill"}>
                                    {renderItemNode(teamSection36FadeInUpsLinkVisible, teamSection36FadeInUpsLinkRenderer, item, (
                                        <SmartLink href={item.link0Href ?? "all_routes.doctorProfile1"} className={item.link0ClassName ?? "team-img"} {...(typeof teamSection36FadeInUpsLinkProps === "function" ? teamSection36FadeInUpsLinkProps(item) : (teamSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Link0LinkProps === "function" ? divDiv0Link0LinkProps(item) : (divDiv0Link0LinkProps ?? {}))}>
                                            {renderItemNode(teamSection36FadeInUpsImageVisible, teamSection36FadeInUpsImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "doctor"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof teamSection36FadeInUpsImageProps === "function" ? teamSection36FadeInUpsImageProps(item) : (teamSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </SmartLink>
                                    ))}
                                    <div className={item.div0ClassName2 ?? "team-content"}>
                                        {renderItemNode(teamSection36FadeInUpsH3Visible, teamSection36FadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof teamSection36FadeInUpsH3Props === "function" ? teamSection36FadeInUpsH3Props(item) : (teamSection36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div0H30H3Props === "function" ? divDiv0Div0H30H3Props(item) : (divDiv0Div0H30H3Props ?? {}))}>
                                                {renderItemNode(teamSection36FadeInUpsLinkVisible, teamSection36FadeInUpsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "all_routes.doctorProfile1"} {...(typeof teamSection36FadeInUpsLinkProps === "function" ? teamSection36FadeInUpsLinkProps(item) : (teamSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div0H30Link0LinkProps === "function" ? divDiv0Div0H30Link0LinkProps(item) : (divDiv0Div0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection36FadeInUpsItemWrapper,
                        teamSection36FadeInUpsRenderer
                    )}
                </div>
                <Slider {...settings} className="partner-slider-seven section-top" {...(sectionDiv0Slider0SliderProps ?? {})}>
                    {renderCollectionNode(
                        teamSectionPartnerSevens,
                        (item: TeamSectionPartnerSevensItem) => (
                            <div className={item.className ?? "partner-item-seven"} key={item.key}>
                                {renderItemNode(teamSectionPartnerSevensImageVisible, teamSectionPartnerSevensImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "client logo"} {...(typeof teamSectionPartnerSevensImageProps === "function" ? teamSectionPartnerSevensImageProps(item) : (teamSectionPartnerSevensImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                            </div>
                        ),
                        teamSectionPartnerSevensItemWrapper,
                        teamSectionPartnerSevensRenderer
                    )}
                </Slider>
            </div>
        </section>
    );
};

export default HomeSevenTeamSectionGenerated;
